export const checkCustomReportsFetching = ({ customReports: { fetchingData } }) => fetchingData;

export const getCustomReportsData = ({ customReports: { data } }) => data;
